// Document-lifetime provider pin. Never switch external providers after a claim.
const owners = new Map();
export function claimDisplayProvider(publicationId, placement, provider) {
  if (!publicationId || !placement) return false;
  const key = JSON.stringify([publicationId, placement]);
  const owner = owners.get(key);
  if (owner && owner !== provider) return false;
  owners.set(key, provider);
  return true;
}
